//
// README
//
// Please reach out to #design-systems if you have any questions or concerns with this component.
//

import React from 'react';
import Helmet from 'react-helmet';
import { RCSwitch } from '@reverbdotcom/cadence/components';
import { ThemeType } from '@reverbdotcom/cadence/components/types';
import { useTheme } from './theme_context_provider';

export const WEB2_THEME_SWITCH_TOGGLE_EVENT = 'WEB2_THEME_SWITCH_TOGGLE_EVENT';

export function Web2ThemeSwitch() {
  const { theme } = useTheme();

  function handleToggle() {
    const newTheme = (theme === ThemeType.web2) ? ThemeType.default : ThemeType.web2;

    window.dispatchEvent(new CustomEvent(WEB2_THEME_SWITCH_TOGGLE_EVENT, { detail: { newTheme } }));
  }

  return (
    <>
      {/* To ensure the Google Font call only happens when this component is rendering */}
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;600;700&display=swap" rel="stylesheet" />
      </Helmet>

      <div className="web2-theme-switch">
        <RCSwitch
          checked={theme === ThemeType.web2}
          label="2.0 Styles"
          onChange={handleToggle}
          id="theme-switch-footer"
        />
      </div>
    </>
  );
}
